<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="顧客詳細"
          icon="customer"
          class="customer-header" />
      <BaseBackButton
          :is-show="showBackButton"
          :return-destination="returnDestination" />
      <BaseDetailMoveData
          :id="customerName"
          :title="moveDataTitle"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="sortedList"
          :path-parameter="movePathParameter"
          :can-move-data="canMoveData"
          router-path="/customer/" />
      <span class="action_button">
        <el-dropdown
            v-show="showActionButton"
            @command="actionCommand">
          <el-button size="small">
            アクション
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
              slot="dropdown"
              class="header-action-menu">
            <el-dropdown-item
                v-show="$isFunctionShown(define.PermissionKeys.Customer.Detail.EDIT)"
                :disabled="$isFunctionDisabled(define.PermissionKeys.Customer.Detail.EDIT)"
                :command="define.CUSTOMER_MODE.CUSTOMER_EDIT">
              顧客情報修正
            </el-dropdown-item>
            <el-dropdown-item
                v-show="$isFunctionShown(define.PermissionKeys.Customer.Detail.REGISTER_POINT)"
                :disabled="$isFunctionDisabled(define.PermissionKeys.Customer.Detail.REGISTER_POINT)"
                :command="define.CUSTOMER_MODE.POINT_NEW">
              ポイント調整
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <BaseButton
            v-show="showCancelButton"
            @click="cancel">
          キャンセル
        </BaseButton>
        <BaseButton
            v-show="showSaveButton"
            @click="save">
          保存
        </BaseButton>
      </span>
    </el-row>
    <el-tabs
        v-model="activeTabName"
        type="border-card">
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Customer.Detail.BASIC_INFO)"
          name="basicInfo">
        <span slot="label"><i class="fas fa-address-card" /> 基本情報</span>
        <el-collapse v-model="activeCollapseName">
          <el-row :gutter="40">
            <el-col :span="12">
              <el-collapse-item
                  v-show="$isFunctionShown(define.PermissionKeys.Customer.Detail.BasicInfo.BASIC_INFO)"
                  title="基本情報"
                  name="basicInfo">
                <BaseTableDetail
                    :table-set-list="basicInfo1"
                    :display-item="customerData"
                    :editable="editable" />
              </el-collapse-item>
            </el-col>
            <el-col :span="12">
              <el-collapse-item
                  v-show="$isFunctionShown(define.PermissionKeys.Customer.Detail.BasicInfo.POINT)"
                  title="ポイント"
                  name="pointInfo">
                <BaseTableDetail
                    :table-set-list="pointInfo1"
                    :display-item="customerData"
                    :editable="editable" />
              </el-collapse-item>
            </el-col>
          </el-row>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Customer.Detail.PURCHASE_HISTORY)"
          name="purchaseHistory">
        <span slot="label"><i class="el-icon-goods" /> 購入履歴</span>
        <BaseTableList
            :table-set-list="purchaseHistoryList"
            :display-items="purchaseHistoryListDisplayData"
            :cell-class-name="''"
            title-class="display-none"
            table-class="customerdetail-table-list"
            class="row-clickable-table"
            @row-click="onRowClick"
            @sort-change="onSortChange" />
        <BasePagination
            :enable-pagination="true"
            :current-page="purchaseHistoryListCurrentPage"
            :size="purchaseHistoryListPageSize"
            :total="purchaseHistoryListTotalSize"
            :total-count="0"
            @size-change="onPaginationPurchaseHistorySizeChange"
            @current-change="onPaginationPurchaseHistoryCurrentChange" />
      </el-tab-pane>
      <el-tab-pane
          v-if="$isFunctionShown(define.PermissionKeys.Customer.Detail.POINT_HISTORY)"
          name="pointHistory">
        <span slot="label"><i class="fas fa-poll-h" /> ポイント履歴</span>
        <BaseTableList
            :table-set-list="pointList"
            :display-items="pointData"
            :cell-class-name="''"
            title-class="display-none"
            table-class="customerdetail-table-list"
            @pagination-current-change="onPaginationCurrentChange" />
      </el-tab-pane>
    </el-tabs>
    <BaseDialog
        title="ポイント調整"
        class="customerdetail-point-modal"
        :visible.sync="dialogVisible"
        :show-only-close-button="false"
        @closed="pointModalCancel"
        @cancel="pointModalCancel"
        @ok="pointModalSave">
      <template slot="contents">
        <div class="table-vertical">
          <table>
            <tr>
              <th>ポイント</th>
              <td>
                <span>{{ adjustPointData.point }}</span>
              </td>
            </tr>
            <tr>
              <th class="required">調整ポイント</th>
              <td>
                <BaseValidNumber
                    v-model="adjustPointData.adjustPoint"
                    v-validate="'required|numCheck'"
                    :error-msg="errors.first('val1Valid')"
                    :popover-error-msg="popover"
                    name="val1Valid"
                    data-vv-as="調整ポイント"
                    @input="changeAdjustPoint" />
              </td>
            </tr>
            <tr>
              <th>調整後ポイント</th>
              <td>
                <span>{{ adjustPointData.afterAdjustPoint }}</span>
              </td>
            </tr>
            <tr>
              <th class="required">理由コード</th>
              <td>
                <BaseValidSelect
                    v-model="adjustPointData.reason"
                    :options="adjustPointData.reasonCodeList"
                    name="reason" />
              </td>
            </tr>
            <tr>
              <th>追加情報</th>
              <td>
                <el-input v-model="adjustPointData.note" />
              </td>
            </tr>
            <tr v-for="(val, index) in adjustPointData.attrs"
                :key="index">
              <th>{{ val.attrLabel }}</th>
              <td>
                <el-input v-model="val.attrValue" />
              </td>
            </tr>
          </table>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<style scoped>
th.required:after {
  content: " *";
  color: #ff5a5a;
  font-size: 85%;
}
</style>

<script>
import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'

import x from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import * as define from '@/define'
import common from '@/utils/common'
import * as config from '@/config'
import message from '@/utils/message'

import BaseValidNumber from '@/components/atoms/BaseValidNumber'
import BaseValidSelect from '@/components/atoms/BaseValidSelect'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import BaseDetailMoveData from '@/components/molecules/BaseDetailMoveData'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseTableList from '@/components/molecules/BaseTableList'
import BasePagination from '@/components/molecules/BasePagination'
import BaseDialog from '@/components/molecules/BaseDialog'
import orderUtil from '@/components/mixins/orderUtil'
import detailUtil from '@/components/mixins/detailUtil'

import * as customerQuery from '@/queries/customer'

const EDITABLE = Object.freeze({
  [define.MODE.NORMAL]: Object.freeze({}),
  [define.MODE.EDIT]: Object.freeze({ name: true, email: true })
})

const customerReturnDestination = '/customer'
const pointReturnDestination = '/point'

const validationRules = (v) => {
  // 設定(値)の形式チェック
  v.$validator.extend('numCheck', {
    getMessage: () => '調整ポイントに0以外の数値を入力してください',
    validate: (data) => {
      if (Number(data) === 0) {
        return false
      }
      return true
    }
  })
}

export default {
  title: '顧客詳細',
  name: 'CustomerDetail',
  components: {
    BaseValidNumber,
    BaseValidSelect,
    BaseButton,
    BaseHeader,
    BaseBackButton,
    BaseDetailMoveData,
    BaseTableDetail,
    BaseTableList,
    BasePagination,
    BaseDialog
  },
  mixins: [ x, orderUtil, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      popover: false,
      customerData: {},
      originData: {},
      purchaseHistoryData: [],
      pointData: [],
      // 調整ポイント
      adjustPointData: {},
      activeTabName: 'basicInfo',
      activeCollapseName: ['basicInfo', 'pointInfo'],
      dialogVisible: false,
      pointListCurrentPage: 0,
      purchaseHistoryListCurrentPage: 0,
      purchaseHistoryListPageSize: 10,
      purchaseHistoryListSortCondition: {},
      canMoveData: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      customerStorePath: (state) => state.Customer.storePath,
      customerListIndex: (state) => state.Customer.listIndex,
      customerSize: (state) => state.Customer.size,
      customerMode: (state) => state.Customer.mode,
      purchaseHistoryListIndex: (state) => state.Customer.purchaseHistory.listIndex,
      purchaseHistorySize: (state) => state.Customer.purchaseHistory.size,
      pointListIndex: (state) => state.Point.listIndex,
      pointSize: (state) => state.Point.size,
      pointMode: (state) => state.Point.mode
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    storePath () {
      return this.customerStorePath || 'Customer'
    },
    pointListName () {
      return this.storePath === 'Point'
        ? 'pointDetailPointList'
        : 'customerDetailPointList'
    },
    listIndex () {
      return this.storePath === 'Point'
        ? this.pointListIndex
        : this.customerListIndex
    },
    sortedList () {
      return this.$store.getters['sortedList'](
        this.storePath, this.sortCondition(this.storePath === 'Point' ? 'pointList' : 'customerList'))
    },
    size () {
      return this.storePath === 'Point'
        ? this.pointSize
        : this.customerSize
    },
    mode () {
      return this.storePath === 'Point'
        ? this.pointMode
        : this.customerMode
    },
    returnDestination () {
      return this.storePath === 'Point'
        ? pointReturnDestination
        : customerReturnDestination
    },
    moveDataTitle () {
      if (this.customerData.nos && this.customerData.nos[0]) {
        return this.customerData.nos[0].no
      } else {
        return ''
      }
    },
    movePathParameter () {
      return this.storePath === 'Point'
        ? ['node.customer.uuid']
        : ['node.uuid']
    },
    customerName () {
      if (!this.$isFunctionShown(define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.NAME)) {
        return ''
      }
      let personalInfo = this.customerData.personalInfo || {}
      return _.chain([personalInfo.lastName, personalInfo.firstName])
        .filter((val) => val)
        .join('　')
        .value()
    },
    // 詳細テーブル
    basicInfo1 () {
      return [
        {
          label: '顧客グループ',
          properties: [
            { path: 'customerGroup.name', type: 'String',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.CUSTOMER_GROUP }
          ]
        },
        {
          label: '顧客番号',
          properties: [
            { path: this.getCustomerNo, type: 'String', elementType: ELEMENT_TYPE.FUNCTION,
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.CUSTOMER_NUMBERS }
          ]
        },
        {
          label: '氏名',
          properties: [
            { path: 'personalInfo.lastName', type: 'String', editableId: 'name', elementType: ELEMENT_TYPE.INPUT,
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.NAME },
            { path: 'personalInfo.firstName', type: 'String', editableId: 'name', elementType: ELEMENT_TYPE.INPUT,
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.NAME }
          ],
          horizontal: true
        },
        {
          label: 'メールアドレス',
          properties: [
            { path: 'personalInfo.email', type: 'String', editableId: 'email', elementType: ELEMENT_TYPE.INPUT,
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.MAILADDRESS }
          ]
        },
        {
          label: '顧客ランク',
          properties: [
            { path: 'rank.name', type: 'String',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.CUSTOMER_RANK }
          ]
        },
        {
          label: '会社名',
          properties: [
            { path: 'personalInfo.companyName', type: 'String',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.COMPANY_NAME }
          ]
        },
        {
          label: '部署・役職',
          properties: [
            { path: 'personalInfo.jobTitle', type: 'String',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.JOB_TITLE }
          ]
        },
        {
          label: '電話番号',
          properties: [
            { path: 'personalInfo.phone', type: 'String',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.PHONE }
          ]
        },
        {
          label: '生年月日',
          properties: [
            { path: 'birthday', type: 'Date', dateFormat: 'YYYY/MM/DD',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.BIRTH_DAY }
          ]
        },
        {
          label: '性別',
          properties: [
            { path: 'gender', type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX,
              selectCode: 'customer_list_condition_value.gender_status', codeName: 'customer_list_condition_value.gender_status',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.GENDER }
          ]
        },
        {
          label: '会員登録日時',
          properties: [
            { path: 'registeredAt', type: 'Date', dateFormat: 'YYYY/MM/DD HH:mm:ss',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.BasicInfo.REGISTERER_AT }
          ]
        }
      ]
    },
    pointInfo1 () {
      return [
        {
          label: '通常ポイント',
          properties: [
            { path: 'point', type: 'Number',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.Point.NORMAL_POINT }
          ]
        },
        {
          label: '通常ポイント有効期限',
          properties: [
            { path: 'pointExpires', type: 'Date', dateFormat: 'YYYY/MM/DD HH:mm',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.Point.EXPIRE }
          ]
        },
        {
          label: '期間限定ポイント',
          properties: [
            { path: 'limitedPoint', type: 'Number',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.Point.LIMITED_POINT }
          ]
        },
        {
          label: '直近有効期限',
          properties: [
            { path: 'limitedPointExpires', type: 'Date', dateFormat: 'YYYY/MM/DD HH:mm',
              funcId: define.PermissionKeys.Customer.Detail.BasicInfo.Point.LIMITED_EXPIRE }
          ]
        }
      ]
    },
    // 一覧テーブル
    pointList () {
      const pointList = [
        { type: 'Date', label: '登録日時', path: 'node.createdAt', width: 200,
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.REGISTERED_AT },
        { type: 'String', label: 'ポイント区分', path: 'node.pointType', codeName: 'd_point.point_type',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.POINT_CATEGORY },
        {
          type: 'String', label: '期間限定フラグ', path: 'node.isLimited',
          elementType: ELEMENT_TYPE.CHECK_BOX, class: 'center',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.LIMITED_FLAG
        },
        { type: 'Number', label: 'ポイント数', path: 'node.point', class: 'right',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.POINT },
        { type: 'Number', label: '残ポイント数', path: 'node.remains', class: 'right',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.REMAINING_POINT },
        { type: 'Date', label: '有効期限', path: 'node.expires', width: 200,
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.EXPIRE },
        { type: 'String', label: '理由コード', path: 'node.reasonCode', codeName: 'd_point.reason_code',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.REASON_CODE },
        { type: 'String', label: '追加情報', path: 'node.note',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.NOTE },
        { type: 'String', label: '内部メモ', path: 'node.memo',
          funcId: define.PermissionKeys.Customer.Detail.PointHistory.MEMO }
      ]
      // 属性情報の追加
      const pointInfoAttr = this.getConfig('d_point', 'point_info_attr')
      Object.keys(pointInfoAttr).forEach((key) => {
        pointList.push(
          {
            itemKey: key, elementType: ELEMENT_TYPE.FUNCTION,
            type: 'String', label: _.get(pointInfoAttr[key], 'label', null),
            path: (row) => {
              const attribute = _.get(row, `node.attributes`, [])
              const returnValue = attribute.find((data) => data.attrId === key)
              return (returnValue || {}).attrValue || ''
            },
            funcId: define.PermissionKeys.Customer.Detail.PointHistory.ATTRIBUTE
          }
        )
      })
      return pointList
    },
    // 購入履歴一覧テーブル
    purchaseHistoryList () {
      return [
        { type: 'String', label: '注文番号', path: 'orderNo', sortable: true, funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.ORDER_NUMBER },
        { type: 'String', label: '配送番号', path: 'shipments|shipmentId', colsep: `
        `, lineBreak: true, funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.SHIPMENT_ID }, // colsep の改行は一覧表示の改行なので、必要
        {
          type: 'String', label: 'サイト', path: ['site.code', 'site.name'], colsep: ': ',
          sortable: true, name: 'site.code', funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.SITE
        },
        { type: 'Date', label: '注文日時', path: 'orderDatetime', sortable: true, funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.ORDER_DATETIME },
        {
          type: 'String', label: '注文者名', sortable: true, sortBy: (row) => {
            return row.orderer.lastName + ' ' + row.orderer.firstName
          },
          path: ['orderer.lastName', 'orderer.firstName'], colsep: ' ',
          funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.ORDERER_NAME
        },
        {
          type: 'String', label: '購入金額',
          path: this.grossPrice, class: 'right',
          elementType: ELEMENT_TYPE.FUNCTION, sortable: true, sortBy: (row) => {
            return Number(row.orderTotalPrice.gross)
          },
          funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.PURCHASE_AMOUNT
        },
        {
          type: 'String', label: '支払ステータス', path: this.paymentStatus, elementType: ELEMENT_TYPE.FUNCTION,
          class: 'center', sortable: true, funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.IS_PAID
        },
        {
          type: 'String', label: '決済種別', path: this.paymentMethod, elementType: ELEMENT_TYPE.TAG,
          class: 'center payment-method-tag', size: 'small', width: '250px', funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.PAYMENT_METHOD
        },
        {
          type: 'String', label: '注文ステータス', path: this.orderStatus, elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag', size: 'small', width: '250px', funcId: define.PermissionKeys.Customer.Detail.PurchaseHistory.ORDER_STATUS
        }
      ]
    },
    showActionButton () {
      return (this.mode === define.MODE.NORMAL &&
             (this.$isFunctionShown(define.PermissionKeys.Customer.Detail.EDIT) ||
              this.$isFunctionShown(define.PermissionKeys.Customer.Detail.REGISTER_POINT)))
    },
    showBackButton () {
      return this.mode === define.MODE.NORMAL && !this.$isFunctionDisabled(define.PermissionKeys.Customer.LIST)
    },
    showSaveButton () {
      return this.mode !== define.MODE.NORMAL
    },
    showCancelButton () {
      return this.mode !== define.MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    },
    purchaseHistoryListTotalSize () {
      return this.purchaseHistoryData.length
    },
    purchaseHistoryListDisplayData () {
      const head = this.purchaseHistoryListCurrentPage * this.purchaseHistoryListPageSize
      return common.sortListData(this.purchaseHistoryData, this.purchaseHistoryListSortCondition).slice(head, head + this.purchaseHistoryListPageSize)
    },
    linkKey () {
      return ['site.code', 'orderNo']
    },
    defaultDispTab () {
      // タブの表示権限を見て、最左のものを選択する。
      if (this.$isFunctionShown(define.PermissionKeys.Customer.Detail.BASIC_INFO)) {
        return 'basicInfo'
      } else if (this.$isFunctionShown(define.PermissionKeys.Customer.Detail.PURCHASE_HISTORY)) {
        return 'purchaseHistory'
      } else if (this.$isFunctionShown(define.PermissionKeys.Customer.Detail.POINT_HISTORY)) {
        return 'pointHistory'
      } else {
        return ''
      }
    }
  },
  async created () {
    try {
      this.$loadingService.show()
      this.activeTabName = this.defaultDispTab

      this.setMode(define.MODE.NORMAL)
      this.getDetailData()
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let storePath
      if (from.name == null) {
        storePath = null
      } else if (from.name === 'PointList') {
        storePath = 'Point'
      } else {
        storePath = 'Customer'
      }
      if (storePath) {
        vm.$store.dispatch({
          type: 'set',
          states: {
            'Customer/storePath': storePath
          }
        })
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    // 顧客詳細間移動時の処理.
    next()
    this.getDetailData()
    this.pointListCurrentPage = 0
    this.purchaseHistoryListCurrentPage = 0
  },
  methods: {
    onPaginationCurrentChange (val) {
      this.pointListCurrentPage = val
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.CUSTOMER_MODE.CUSTOMER_EDIT:
          this.customerEdit()
          break
        case define.CUSTOMER_MODE.POINT_NEW:
          this.pointRegister()
          break
        default: {}
      }
    },
    /**
     * 顧客編集
     */
    customerEdit () {
      // TODO 変更の監視（F5対応とかも）
      this.setMode(define.MODE.EDIT)
    },
    /**
     * ポイント登録
     */
    pointRegister () {
      this.dialogVisible = true
      // ポイント調整情報取得
      this.getAdjustPointData()
      // カスタムバリデーションルールを追加
      validationRules(this)
    },
    /**
     * 保存
     */
    save () {
      this.setMode(define.MODE.NORMAL)
    },
    /**
     * 中止
     */
    cancel () {
      this.setMode(define.MODE.NORMAL)
    },
    getCustomerNo () {
      return _.chain(this.customerData.nos)
        .reduce((acc, cur) => {
          // let type = cur.type ? ` (${cur.type})` : ''
          // acc.push(`${cur.no}${type}`)
          acc.push(`${cur.no}`)
          return acc
        }, [])
        .join(', ')
        .value()
    },
    /**
     * 調整後ポイントを返却します。
     */
    changeAdjustPoint () {

      // 調整後ポイント = ポイント + 調整ポイント
      this.adjustPointData.afterAdjustPoint =
        Number(this.adjustPointData.point) + Number(this.adjustPointData.adjustPoint)
    },
    /**
     * ポイント登録中止
     */
    pointModalCancel () {
      this.doDestroyed()
    },
    /**
     * ポイント登録保存
     */
    async pointModalSave () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // URLの準備
          const url = config.POINT_URL
          // メソッド
          const method = 'post'
          // 属性の準備
          const attributes = this.adjustPointData.attrs
            .filter(val => _.trim(val.attrValue) !== '')
            .map(v => ({ attrId: v.attrId, attrValue: v.attrValue }))
          // 理由コードの準備
          const reasonCode = this.adjustPointData.reasonCodeList.find((data) =>
            data.code === this.adjustPointData.reason).reasonCode

          // 理由コードの値１を取得
          const isExpUpdate = this.adjustPointData.reasonCodeList.find((data) =>
            data.code === this.adjustPointData.reason).isExpUpdate

          // 有効期限の取得
          let pointExpires = this.customerData.pointExpires
          // 選択した理由コードの値2(有効期限更新フラグ)= 1場合
          if (isExpUpdate in ['1', '4']) {
            if (this.customerData.customerGroup.pointBaseConfig != null) {
              // 有効期限
              const expires = this.customerData.customerGroup.pointBaseConfig.expires
              // 有効期限単位
              const expiresUnit = this.customerData.customerGroup.pointBaseConfig.expiresUnit
              // 失効ルール
              const expireRule = this.customerData.customerGroup.pointBaseConfig.expireRule

              // 失効ルールが1(最終有効期限)の場合、有効期限=現在日時+(有効期限 * 有効期限単位)
              if (expireRule === 1) {
                pointExpires = this.getExpires(expires, expiresUnit)
              } else {
                pointExpires = null
                // 失効ルールが2(最後注文日時後)の場合、有効期限 = NULL       次期対応
                // 失効ルールが3(ポイント単位)の場合、有効期限 = 入力欄の値    次期対応
              }
            }
          }

          // REQUEST BODYの作成
          const data = {
            'gcd': this.customerData.customerGroup.code, // 顧客グループコード
            'cno': this.customerData.nos[0].no, // 顧客番号
            'point': this.adjustPointData.adjustPoint, // ポイント数
            'type': 3, // 履歴種別 (1=付与, 2=利用, 3=調整)
            'reason': reasonCode, // 理由コード
            'expire': pointExpires // 有効期限
          }
          // 追加情報入力のみ
          if (_.trim(this.adjustPointData.note) !== '') {
            data.note = this.adjustPointData.note // 追加情報
          }
          // 属性情報入力のみ
          if (attributes.length > 0) {
            data.attributes = attributes // 属性情報
          }

          // ポイント付与・利用APIをコール
          await common.apiAxios(url, { method, data })

          this.$notify.success('保存しました。')
          // ポイントリストの再取得
          this.pointData = await this.getPointList()
          // ダイアログdestroy
          this.doDestroyed()
          this.getDetailData()
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_565() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * データ取得
     */
    getDetailData: async function (updateList = false) {
      try {
        this.$loadingService.show()
        const customer = await this.getCustomer()
        if (customer == null) {
          // 結果が null の場合
          this.$notify.error({
            message: '顧客情報を取得できませんでした。'
          })
          return
        }
        this.customerData = customer
        this.originData = _.cloneDeep(this.customerData)

        // listIndexの更新
        this.$_detailUtil_onGetDetailData((element) => element.node.uuid === this.$route.params.id)

        if (updateList) {
          // TODO 一覧更新
          // this.updateListItem(this.orderDetail);
        }

        const pointList = await this.getPointList()
        if (pointList == null) {
          // 結果が null の場合
          this.$notify.error({
            message: 'ポイント履歴を取得できませんでした。'
          })
          return
        }

        this.pointData = pointList
        this.purchaseHistoryData = this.originData.latestOrders

      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * ダイアログdestroy
     */
    doDestroyed () {
      this.$validator.reset()
      this.dialogVisible = false
    },
    async getCustomer () {
      const query = common.addGraphQlCondition(customerQuery.GRAPH_QL_QUERY_CUSTOMER_DETAIL,
        { uuid: this.$route.params.id })
      const res = await common.postGraphQl(query)
      return res.data.data.customer
    },
    async getPointList () {
      const query = common.addGraphQlCondition(customerQuery.GRAPH_QL_QUERY_POINT_LIST,
        {
          customerGroupCodes: this.customerData.customerGroup.code,
          customerNos: _.map(this.customerData.nos, 'no')
        }
      )
      const res = await common.postGraphQl(query)
      return res.data.data.points.edges
    },
    getAdjustPointData () {
      // ポイント調整モード(radio)チェックボックスで切り替わる(次期対応)
      // this.adjustPointData.pointAdjustmentMode = '1'

      // 属性リストを取得する
      const attrs = []
      const pointInfoAttr = this.getConfig('d_point', 'point_info_attr')
      Object.keys(pointInfoAttr).forEach((key) => {
        attrs.push(
          {
            attrId: key,
            attrValue: '',
            attrLabel: _.get(pointInfoAttr[key], 'label', null)
          })
      })

      // 理由コードリストを取得する
      const reasonCodeList = []
      const reasons = this.getConfig('d_point', 'reason_code')
      Object.keys(reasons).forEach((key) => {
        reasonCodeList.push(
          {
            code: key,
            name: _.get(reasons[key], 'v.0', null) + ' - ' + _.get(reasons[key], 'label', null),
            reasonCode: _.get(reasons[key], 'v.0', null),
            isExpUpdate: _.get(reasons[key], 'v.1', null)
          })
      })

      this.adjustPointData = {
        point: this.customerData.point, // ポイント
        adjustPoint: '', // 調整ポイント
        afterAdjustPoint: 0, // 調整後ポイント
        reason: reasonCodeList.length > 0 ? reasonCodeList[0].code : '', // 理由コード
        note: '', // 追加情報
        attrs: attrs, // 属性リスト
        reasonCodeList: reasonCodeList // 理由コードリスト
      }
    },
    getConfig: function (key1, key2) {
      return this.getServiceSiteConfig(null, key1, key2) || []
    },
    setMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          [`${this.storePath}/mode`]: mode
        }
      })
    },
    paymentStatus: function (row) {
      if (row == null || row === undefined || !row.payments) {
        return ''
      }
      let paymentStatus = this.$_orderUtil_orderPayment_isPaid(row.payments.at(-1), row.isPaid, row.orderTotalPrice.gross)
      return this.$_mixin_getCodeName(paymentStatus, 'd_order.is_paid', { siteCode: this.siteCode })
    },
    paymentMethod: function (row) {
      return this.$_orderUtil_orderPaymentTag(row.payments)
    },
    orderStatus: function (row) {
      return this.$_orderUtil_headerOrderStatusTag(row)
    },
    grossPrice: function (row) {
      return common.concatCurrency(row.orderTotalPrice.gross, row.currency)
    },
    onPaginationPurchaseHistoryCurrentChange (val) {
      this.purchaseHistoryListCurrentPage = val
    },
    onPaginationPurchaseHistorySizeChange (val) {
      this.purchaseHistoryListPageSize = val
    },
    onRowClick (row, column, event) {
      const id = this.$_mixin_getData(row, this.linkKey, '&')
      this.$_mixin_onLinkClick(-1, 'Order')
      this.$router.push({ path: `/order/${id}` })
    },
    findIndex (row) {
      let condition = _.chain(this.linkKey)
        .reduce((acc, cur) => {
          acc[cur] = _.get(row, cur)
          return acc
        }, {})
        .value()
      return this.$_mixin_findIndex(this.sortedList, condition)
    },
    onSortChange ({ column, prop, order }) {
      this.purchaseHistoryListSortCondition = {
        prop,
        order,
        sortBy: (!column || !column.sortBy) ? null : column.sortBy
      }
    },
    /**
     * 有効期限を取得します。
     * @param {*} expiresUnit 有効期限単位
     * @param {*} expiresAt 有効期限(指定日)
     * @return {*} 有効期限
     */
    getExpires (expires, expiresUnit) {
      const d = new Date()
      switch (expiresUnit) {
        case 10: // 年
          d.setFullYear(d.getFullYear() + expires)
          return d
        case 11: // 年後末
          d.setFullYear(d.getFullYear() + expires)
          d.setMonth(12)
          d.setDate(0)
          return d
        case 20: // ヶ月
          d.setMonth(d.getMonth() + expires)
          return d
        case 21: // ヶ月後末
          d.setMonth(d.getMonth() + expires + 1)
          d.setDate(0)
          return d
        case 30: // 日
          d.setDate(d.getDate() + expires)
          return d
        case 40: // 時間
          d.setHours(d.getHours() + expires)
          return d
      }
      return null
    }
  }
}
</script>
